import { requestGet } from '@/common/request';
import { useEffect, useMemo, useState } from 'react';
import batchedupdates from '@/common/utils/batched-updates';
import { message } from 'antd';
import { LOAD_STATUS } from '@/components/loadable';

export interface getChannelParams {
  channelId: string;
}

export interface getChannelRes {
  ret: string;
  msg: string;
  data?: {
    id: number;
    supportOpenActivity: number;
    channelId: string;
    name: string;
    pic: string;
    order: string;
    remark: string;
    linkType: number;
    link: string;
    online: number;
    channelLevel: number;
    childChannelCount: number;
    channelType: number;
    channelIdChain: Array<string> | [];
    channelNameChain: Array<string> | [];
    activityCount: number;
    isCollect: number;
    supportSkill: number;
    businessType: string;
  };
}

//查询频道信息
export async function getChannel(params: getChannelParams): Promise<getChannelRes> {
  return await requestGet('/channelActivity/getChannel', params);
}

export function useGetChannelInfo(query: getChannelParams) {
  const [loadStatus, setLoadStatus] = useState(LOAD_STATUS.FIRST);
  const [state, setState] = useState<any>();

  useEffect(() => {
    if (!query) return;
    let didMount = true;
    setLoadStatus(LOAD_STATUS.ING);
    getChannel(query)
      .then((res) => {
        if (!didMount) return;

        const { ret, msg } = res || {};
        if (ret !== '0') {
          message.error(msg || '网络异常请稍候~');
          setLoadStatus(LOAD_STATUS.FAILED);
          return;
        } else {
          batchedupdates(() => {
            setState(res?.data);
            setLoadStatus(LOAD_STATUS.SUCCESS);
          });
        }
      })
      .catch((ex) => {
        setLoadStatus(LOAD_STATUS.FAILED);
        console.error(ex);
      });

    return () => {
      didMount = false;
    };
  }, [query]);

  const data = useMemo(() => {
    const loading = loadStatus === LOAD_STATUS.ING || loadStatus === LOAD_STATUS.FIRST;
    return { loading, data: state, loadStatus };
  }, [loadStatus, state]);

  return [data];
}
